export const CURRENT_SESSION = "w_p_sc_d_c";
export const TODAY_KEY = "w_p_sc_d";
